import { type RefObject, useState } from 'react'
import { useResizeObserver } from '../../../../hooks/useResizeObserver'

/** @deprecated */
export function useSelectState({
  triggerRef,
  minWidth = 200,
}: {
  triggerRef: RefObject<HTMLButtonElement>
  minWidth?: number
}) {
  const [isOpen, setOpen] = useState(false)
  const [popoverMinWidth, setPopoverMinWidth] = useState<number | undefined>(
    undefined,
  )

  useResizeObserver({
    ref: triggerRef,
    onResize(e) {
      if (e) {
        setPopoverMinWidth(Math.max(e.contentRect.width, minWidth))
      }
    },
  })

  return {
    isOpen,
    setOpen,
    popoverMinWidth,
  }
}
